import {ProductDetailRes} from "../product.contract";
import {MinTrackerRes, TrackerCreateReq, TrackerDetailRes} from "./tracker.contract";
import {BaseSearchModel} from "../core";
import {Type} from 'class-transformer';
import {CompanyDetailsRes} from '../../cp';

export class AcquisitionTrackerRes extends TrackerDetailRes {
    @Type(() => ProductDetailRes)
  product!: ProductDetailRes;
    @Type(() => CompanyDetailsRes)
  company!: CompanyDetailsRes;

}
export class MinAcquisitionTrackerRes extends MinTrackerRes{
    @Type(() => ProductDetailRes)
  product!:ProductDetailRes;
    @Type(() => CompanyDetailsRes)
  company!:CompanyDetailsRes;
}
export class AcquisitionTrackerCreateReq extends TrackerCreateReq {
  companyId!: number;
  productId!: string;
}
export class AcquisitionTrackerSearchReq extends BaseSearchModel {
  companyId?: number;
  id?: number;
}
